module.exports = __webpack_public_path__ + "img/portrait.61f5014d.svg";